export default "__VITE_ASSET__DIc_WGwX__"